
import React from 'react';

const Dashboard = () => {
  return (
    <div className="relative reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '200ms' }}>
      <div className="relative z-10">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-blue-100">
          <div className="bg-gray-50 p-4 border-b border-gray-100 flex items-center">
            <div className="w-3 h-3 rounded-full bg-red-400 mr-2"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-400 mr-2"></div>
            <div className="w-3 h-3 rounded-full bg-green-400 mr-2"></div>
            <div className="text-gray-500 text-sm ml-2">Dashboard</div>
          </div>
          <div className="p-0">
            <img 
              src="/lovable-uploads/portfolio_overview_portco.png" 
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
      
      <div className="absolute top-6 -left-6 -z-10 w-full h-full bg-gradient-to-br from-blue-100 to-purple-100 rounded-xl transform rotate-6"></div>
    </div>
  );
};

export default Dashboard;
